















import { Component, Prop, Vue } from 'vue-property-decorator';

export enum MenuElementBgColor {
  Primary = 'menu-element--primary',
  Secondary = 'menu-element--secondary',
  BlueDark = 'menu-element--blue-dark',
  Red = 'menu-element--red',
  Gold = 'menu-element--gold',
}

export enum MenuElementBgColorHover {
  Primary = 'menu-element--hover-primary',
  Secondary = 'menu-element--hover-secondary',
  BlueDark = 'menu-element--hover-blue-dark',
  Red = 'menu-element--hover-red',
  Gold = 'menu-element--hover-gold',
  Auto = 'menu-element--hover-auto',
}

export enum MenuElementSize {
  Auto = 'menu-element--auto-size',
}

@Component
export default class MenuElement extends Vue {
  @Prop() private title!: string;
  @Prop({ default: false }) private flat!: boolean;
  @Prop({ default: MenuElementBgColor.BlueDark })
  private color!: MenuElementBgColor;
  @Prop() private hoverColor!: MenuElementBgColorHover;
  @Prop() private size!: MenuElementSize;

  private menuElementClicked(e: any) {
    e.stopPropagation();
    this.$emit('menu-element-click');
  }
}
